/**
 * Korean (KRW) mock transactions. Transfer pairs carry the same `paired*`
 * fields the app's groupTransferPairs() produces, so the real DoubleRow
 * component renders the two-sided sublines.
 */

/** @type {Array<import('../../mock-transactions.js').MockTransaction>} */
export const MOCK_TRANSACTIONS_KO = [
	{
		id: 'txn-1',
		date: '2026-08-03',
		type: 'Deposit',
		amount: 3500000,
		description: '월급',
		accountId: 'acc-checking',
		accountName: '새봄은행',
		currency: 'KRW',
		currencySymbol: '\u20A9',
		currencyDecimalPlaces: 0,
		tagNames: '수입',
	},
	{
		id: 'txn-2',
		isTransferPair: true,
		date: '2026-08-01',
		type: 'Transfer',
		amount: 500000,
		description: '저축으로',
		accountId: 'acc-checking',
		accountName: '새봄은행',
		currency: 'KRW',
		currencySymbol: '\u20A9',
		currencyDecimalPlaces: 0,
		tagNames: '저축',
		pairedType: 'Transfer',
		pairedAmount: 500000,
		pairedCurrencySymbol: '\u20A9',
		pairedCurrencyDecimalPlaces: 0,
		pairedAccountName: '정기예금',
		pairedAccountId: 'acc-savings',
		pairedDate: '2026-08-01',
	},
	{
		id: 'txn-3',
		isTransferPair: true,
		date: '2026-08-01',
		type: 'Regular Investment',
		amount: 500000,
		description: '펀드 적립',
		accountId: 'acc-checking',
		accountName: '새봄은행',
		currency: 'KRW',
		currencySymbol: '\u20A9',
		currencyDecimalPlaces: 0,
		tagNames: '투자',
		pairedType: 'Regular Investment',
		pairedAmount: 500000,
		pairedCurrencySymbol: '\u20A9',
		pairedCurrencyDecimalPlaces: 0,
		pairedAccountName: '성장형 펀드',
		pairedAccountId: 'acc-broker',
		pairedDate: '2026-08-01',
	},
	{
		id: 'txn-4',
		isTransferPair: true,
		date: '2026-07-20',
		type: 'Credit Card Payment',
		amount: 1240000,
		description: '리워드 카드 대금',
		accountId: 'acc-checking',
		accountName: '새봄은행',
		currency: 'KRW',
		currencySymbol: '\u20A9',
		currencyDecimalPlaces: 0,
		tagNames: '공과금',
		pairedType: 'Credit Card Payment',
		pairedAmount: 1240000,
		pairedCurrencySymbol: '\u20A9',
		pairedCurrencyDecimalPlaces: 0,
		pairedAccountName: '리워드 카드',
		pairedAccountId: 'acc-credit',
		pairedDate: '2026-07-20',
	},
	{
		id: 'txn-5',
		date: '2026-07-24',
		type: 'Withdrawal',
		amount: 100000,
		description: '현금 인출',
		accountId: 'acc-checking',
		accountName: '새봄은행',
		currency: 'KRW',
		currencySymbol: '\u20A9',
		currencyDecimalPlaces: 0,
		tagNames: '현금',
	},
	{
		id: 'txn-6',
		date: '2026-07-22',
		type: 'Purchase',
		amount: 54000,
		description: '마트',
		accountId: 'acc-credit',
		accountName: '리워드 카드',
		currency: 'KRW',
		currencySymbol: '\u20A9',
		currencyDecimalPlaces: 0,
		tagNames: '식비',
	},
	{
		id: 'txn-7',
		date: '2026-07-18',
		type: 'Reward Earned',
		amount: 4200,
		description: '마일리지 적립',
		accountId: 'acc-flight',
		accountName: '항공 마일리지',
		currency: 'MILES',
		currencySymbol: '\u2708',
		currencyDecimalPlaces: 0,
		tagNames: '마일리지',
	},
];

/** @type {Array<import('../../mock-transactions.js').MockTransaction>} */
export const MOCK_AVIOS_TRANSACTIONS_KO = [
	{
		id: 'av-1',
		date: '2026-08-02',
		type: 'Reward Earned',
		amount: 5600,
		description: '호텔 숙박 보너스',
		accountId: 'acc-flight',
		accountName: '항공 마일리지',
		currency: 'MILES',
		currencySymbol: '\u2708',
		currencyDecimalPlaces: 0,
		tagNames: '마일리지',
	},
	{
		id: 'av-2',
		date: '2026-07-28',
		type: 'Reward Redemption',
		amount: 20000,
		description: '보너스 항공권 (이코노미)',
		accountId: 'acc-flight',
		accountName: '항공 마일리지',
		currency: 'MILES',
		currencySymbol: '\u2708',
		currencyDecimalPlaces: 0,
		tagNames: '여행',
	},
	{
		id: 'av-3',
		date: '2026-07-18',
		type: 'Reward Earned',
		amount: 4200,
		description: '항공 보너스',
		accountId: 'acc-flight',
		accountName: '항공 마일리지',
		currency: 'MILES',
		currencySymbol: '\u2708',
		currencyDecimalPlaces: 0,
		tagNames: '마일리지',
	},
];
